var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuyCreditsIcon = function SvgBuyCreditsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M3.585 9.078A1 1 0 0 1 4.582 8h14.836a1 1 0 0 1 .997 1.078l-.642 8.157A3 3 0 0 1 16.783 20H7.217a3 3 0 0 1-2.991-2.765z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M16 10.505V6.7A2.7 2.7 0 0 0 13.3 4h-2.6A2.7 2.7 0 0 0 8 6.7v3.805"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.7,
    d: "M8.5 16.035h7"
  })));
};
export default SvgBuyCreditsIcon;